import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { UGCWorkspacePage } from "~/components/UGCWorkspace/UGCWorkspacePage"
import AppLayout from "~/layouts/AppLayout"

const ugcSearchSchema = z
  .object({
    // `/create/ugc?template=talking_avatar_01` hydrates the prompt bar with avatar + script.
    template: z.string().optional(),
    // `/create/ugc?asset=<assetId>` deeplinks straight into the lightbox for that attempt
    // (shareable + refresh-safe + Back closes the overlay).
    asset: z.string().optional(),
  })
  .partial()

function UGCWorkspaceRoute() {
  return (
    <AppLayout navCollapsible="icon" navIconFloat fixedViewport>
      <UGCWorkspacePage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/create/ugc" as any)({
  validateSearch: ugcSearchSchema,
  component: UGCWorkspaceRoute,
})
